import {IUser} from "shared/types/IUser";

export const useUserModules = (module: string) => {
    const user: IUser = JSON.parse(localStorage.getItem('User')!);
    return user.modules.includes(module);
};